import Toolbar from "csi/def/Toolbar";
import DocumentProperties from "src/SiteAdmin/DocumentProperties";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

export = declare(DocumentProperties, {
	customViewOptionsComponent: null,
	disableCustomViewToolbar: true,

	// String[]: reset plugins to be filled in later
	plugins: [],

	// Boolean: indicate we only want to work with shared custom views
	prefSiteOnly: true,

	/**
	 * @override
	 * Custom views are enabled even though disabling standard custom view toolbar controls
	 */
	supportsCustomViews() {
		return true;
	},

	/**
	 * @override
	 * Add toolbar to select the custom view if in configuration view
	 */
	_resolveView() {
		if (!this.getViewNode()) {
			this.defView.defToolbar = lang.mixin(new Toolbar(), {
				m_actions: [
					"CustomViewManageButton",
					"CustomViewSelect",
				],
			});
		}

		this.inherited(arguments);
	},
});
